import type { ReactNode } from 'react';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { useBusinessDay } from '../../../../shared/hooks/useBusinessDay.js';
import type { ClearedWorkflow } from '../../../../shared/contracts/completed-work.js';

/**
 * Every workflow that passed a piece of work, in the order it ran, each with
 * its own levels named and in order. The vendor asked to see how far his job
 * travelled, not a single "verified" flag; a job raised from a branding
 * request runs the request's approval and then its own chain, and each is
 * shown as itself.
 */
export function ClearedBy({ workflows }: { readonly workflows: readonly ClearedWorkflow[] }): ReactNode {
  const { t } = useTranslation();
  const { atDay } = useBusinessDay();
  if (workflows.length === 0) return '\u2014';
  return (
    <div>
      {workflows.map((w, i) => (
        <div key={`${i}-${w.workflowName}`} data-testid="cleared-workflow">
          <strong>{w.workflowName}</strong>
          <ol style={{ margin: 0, paddingLeft: 18 }}>
            {w.levels.map((v) => (
              <li key={`${v.level}-${v.name}`}>
                {v.name}
                <span style={{ color: 'var(--color-text-muted, #656d76)' }}>
                  {' \u2014 '}
                  {t(`billing.cleared.status.${v.status}`)}
                  {v.actionedAt ? ` ${t('billing.cleared.on', { date: atDay(v.actionedAt) })}` : ''}
                </span>
              </li>
            ))}
          </ol>
        </div>
      ))}
    </div>
  );
}
